import IconAsMaskImage from "../IconAsMaskImage";

const Warning = ({ pureSvg, className, color }) => {
  const svg = (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
      >
        <g transform="translate(-0.425 -0.425)">
          <rect
            width="17"
            height="17"
            transform="translate(0.425 0.425)"
            fill="#e63939"
            opacity="0"
          />
          <path
            d="M9.25,2A7.25,7.25,0,1,0,16.5,9.25,7.25,7.25,0,0,0,9.25,2Zm0,10.875a.725.725,0,1,1,.725-.725A.725.725,0,0,1,9.25,12.875Zm.725-2.9a.725.725,0,0,1-1.45,0V6.35a.725.725,0,1,1,1.45,0Z"
            transform="translate(-0.55 -0.55)"
            fill="#e63939"
          />
        </g>
      </svg>
    </>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
};

export default Warning;
